import React from 'react';
import { CoopLiveEditor } from '../live/CoopLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';

export function CoopBuilder(props: StudioLiveEditorProps) {
  return <CoopLiveEditor {...props} />;
}
